/**
 * Dashboard Cue Notes Filter - Aligned with DashboardExternalTasksFilter
 * Same structure: CustomFilter only with version2, onResetForm, analytics
 * Fields: Search, Placement ID, Reply Status, Date Range (Created)
 */
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  getDashboardCueNotesFilterSpecs,
  defaultCueNotesFilterValues,
} from './DashboardFilterUtils';

export const defaultValues = defaultCueNotesFilterValues;

export interface DashboardCueNotesFilterProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
  onAfterReset?: () => void;
  repliedCount?: number;
  pendingCount?: number;
}

export const DashboardCueNotesFilter: React.FC<DashboardCueNotesFilterProps> = ({
  onApplyFilter,
  onAfterReset,
  repliedCount = 0,
  pendingCount = 0,
}) => {
  const { setValue } = useFormContext();
  const fields = useMemo(
    () => getDashboardCueNotesFilterSpecs(repliedCount, pendingCount),
    [repliedCount, pendingCount]
  );

  const resetFilter = () => {
    Object.entries(defaultCueNotesFilterValues).forEach(([key, val]) => setValue(key, val));
    onApplyFilter(defaultCueNotesFilterValues);
    onAfterReset?.();
  };

  return (
    <CustomFilter
      fields={fields}
      onResetForm={resetFilter}
      justifyContent="flex-start"
      version2
      analytics={{ caller: 'TaskOperations', onApply: true, properties: { category: 'Dashboard Cue Notes' } }}
    />
  );
};
